import { BrowserRouter as Router } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Loading, generalRouter } from 'Components'
import { connect } from 'react-redux'
import { setWindowDims } from 'Actions/explore'
import routes from './routes'
import './App.scss'
import 'wvrio-styleguide/src/App.scss'
import WeaverService from 'Services/WeaverService'
import { Layout } from 'antd'
AppRouter = generalRouter(routes)

if process.env.NODE_ENV is 'production'
  console.log(
    "%c U dev? \n %c Get in touch: %cidev@weaverhq.com"
    "font-weight: bold; font-size: 55px; font-family: Helvetica; color: #58bd91;",
    "font-weight: bold; font-size: 20px; font-family: Helvetica; color: #303035;",
    "font-family: Helvetica; font-size: 20px; color: rgb(31, 125, 204); text-decoration: underline;"
  )

App = ({ setWindowDims, currentProject, darkModeEnabled }) ->

  [loading, setLoading] = useState(true)

  window.onresize = ->
    setWindowDims(window.innerWidth, window.innerHeight)

  useEffect( ->
    if darkModeEnabled
      className = 'theme-dark'
    else
      className = 'theme-light'
    document.getElementById('body').classList = className
    undefined
  , [darkModeEnabled])

  useEffect(->
    (->
      await WeaverService.init()
      setLoading(false)
    )()
    undefined
  , [])

  if loading
    <Loading />
  else
    <Router>
      <Layout style={{ height: '100vh' }}>
        <AppRouter />
      </Layout>
    </Router>

export default connect(({ explore: { darkModeEnabled }, projects: { currentProject }}) ->
  { currentProject, darkModeEnabled }
, { setWindowDims }
)(App)
